import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section id="hero" className="hero">
      <div className="hero-content">
        <img 
          src="/images/logo.png" 
          alt="SDRA24 Logo" 
          className="hero-logo"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
            const fallback = target.nextElementSibling as HTMLElement;
            if (fallback) fallback.style.display = 'block';
          }}
        />
        <h1 className="hero-logo-fallback">SDRA24</h1>
        <h2 className="hero-subtitle">Shaun De Souza Rugby Academy</h2>
        <p className="hero-tagline">Grassroots to Greatness</p>
        <div className="hero-description">
          <p>High-performance rugby development academy committed to identifying, developing, and preparing young athletes through a structured, values-driven pathway.</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;

